import { VideoPlayer } from '@components/videodetails/v2/videoplayer'
import { VideoDetailsComponent } from '@components/videodetails/v2/videoplayer/videodetails'

document.querySelector('.cmp-videodetails__video')
  ? new VideoDetailsComponent(document.querySelector('.cmp-videodetails__video'))
  : document.querySelectorAll('.cmp-video-wrapper').forEach(element => new VideoPlayer(element as HTMLDivElement))
